import React from 'react';
import PropTypes from 'prop-types';

export class SearchIcon extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const iconClassNames = this.props.iconClassNames || '';
        const style = {
            color: this.props.color
        };
        return (<div className="search-icon" style={style} onClick={this.props.onClickHandler}>
            <span className={`togo-icon togo-icon-search ${iconClassNames}`}></span>
        </div>);
    }
}

SearchIcon.propTypes = {
    onClickHandler: PropTypes.func.isRequired,
    iconClassNames: PropTypes.string,
    color: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/icons/search-icon.js